"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyle = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyle = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  div: {
    direction: "rtl",
    position: "relative"
  },
  input: {
    fontFamily: "IranSansX",
    fontSize: "14px",
    textAlign: "right",
    border: "1px solid ".concat(_variables.colors.hare),
    background: _variables.colors.swan,
    color: _variables.colors.wolf,
    position: "relative",
    width: "100%",
    height: "40px",
    borderRadius: "10px",
    textIndent: "58px",
    "&:placeholder": {
      fontSize: "14px"
    }
  },
  span: {
    position: "absolute",
    width: "22px",
    height: "22px",
    right: "23px",
    top: "50%",
    transform: "translateY(-50%)"
  }
}), {
  name: 'pds-search-input'
});
exports.useStyle = useStyle;